
import {Component, Vue} from 'vue-property-decorator';
import {IUserProfile} from '@/interfaces/user';
import {
  dispatchCreateUser, dispatchGetExternalUserAdminById, dispatchGetExternalUsersAdmin, dispatchGetFormsAdmin,
  dispatchGetGroups, dispatchGetInstitutions, dispatchGetPermissions,
  dispatchGetRolesAdmin,
  dispatchGetUserAdmin,
} from '@/store/admin/actions';
import {
  readAdminExternalUser,
  readAdminExternalUsers,
  readAdminForms,
  readAdminGroups,
  readAdminRoles, readInstitutions,
} from '@/store/admin/getters';
import {rules, stringToNumber} from '@/utils';
import {readPermissions, readUserProfile} from '@/store/main/getters';

@Component
export default class CRUDExternalUser extends Vue {
  private title: string = `${this.$t('crud.create')} ${this.$t('external_user')}`;
  private password2: string = '';
  private userId: number = -1;
  private rules: any = rules;
  private resetPassword: boolean = false;

  private valid: boolean = true;
  private user: IUserProfile = {is_active: true} as IUserProfile;

  private userPermissionsToSave: number[] = [];
  private groupsToSave: number[] = [];
  private formsToSave: number[] = [];

  private get currentUser() {
    return readUserProfile(this.$store);
  }

  public async mounted() {
    this.userId = Number(this.$router.currentRoute.params.id);
    if (!this.roles.length) {
      await dispatchGetRolesAdmin(this.$store);
    }
    await dispatchGetInstitutions(this.$store);

    await dispatchGetGroups(this.$store);
    await dispatchGetPermissions(this.$store);
    await dispatchGetFormsAdmin(this.$store);

    if (this.userId > 0) {
      await dispatchGetExternalUserAdminById(this.$store, this.userId);
      this.user = readAdminExternalUser(this.$store)(+this.userId) as IUserProfile;
      if (this.user) {
        this.user.is_active = true;
      }
    } else {
      this.reset();
      this.userId = 0;
    }
  }

  public beforeRouteLeave(to, from, next) {
    this.user = {is_active: true} as IUserProfile;
    this.title = `${this.$t('crud.create')} ${this.$t('external_user')}`;
    this.userId = 0;
    next();
  }

  public reset() {
    this.user = {is_active: true} as IUserProfile;
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    const form: any = this.$refs.form_crud_user;
    if (!form.validate()) {
      return;
    }

    if (this.userId <= 0) {
      return;
    }

    const userToSave = {
      ...this.user,
      groups: this.groupsToSave,
      permissions: this.userPermissionsToSave,
      forms: this.formsToSave,
      cpf: stringToNumber(this.user.cpf),
    } as unknown as IUserProfile;

    const createdUser = await dispatchCreateUser(this.$store, {userProfile: userToSave, externalUserID: this.userId});
    if (createdUser) {
      await this.$router.push({name: 'main-admin-users-external-users-list'});
    }
  }

  private get roles() {
    return readAdminRoles(this.$store);
  }

  private get institutions() {
    return readInstitutions(this.$store);
  }

  private get userPermissions() {
    return readPermissions(this.$store);
  }

  private get groupPermissions() {
    return readAdminGroups(this.$store);
  }

  private get forms() {
    return readAdminForms(this.$store);
  }
}
